
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class StockResarvationUpdateStatusService extends BaseApiTemplateService<any> {
  // readonly base_url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX;

  // https://api.akaun.cloud/core2/tnt/dm/erp/inventory-stock-reservation-hdrs/backoffice-ep/update-posting-status

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "inventory-stock-reservation-hdrs/backoffice-ep/update-posting-status";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "inventory-stock-reservation-hdrs/backoffice-ep/update-posting-status";
    this.httpClient = http;
  }

  UpdatePostingStatus(guid: string, posting_status: string, visa: ApiVisa): Observable<any> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
  
    const body = {
      guid: guid,
      posting_status: posting_status,
    };
  
    return this.httpClient.put<ApiResponseModel<any>>(this.apiUrl, body, this.getHttpHeader(visa));
  }  
}

